import React from 'react';
import { Box } from '@mui/material';
import AssignCardApp from "../../../../Cards/Functionality/AssignCardApp";
import CustomModal from "../../../../../components/Modal/CustomModal";
import CustomDescriptionLabel from "../../../../../components/CustomDescriptionLabel";
import CustomAddChipSearch from "../../../../../components/CustomAddChipSearch";
import {USER_TYPE_MODEL} from "../../../../../enums/userTypeEnum";
import {userListToLabelEmailPhoneValue} from "../../../../../Apis/functions";
import {PersonChipBlack} from "../../../../../components/buttons/IconButtons";

const AssignCardModal = (props) => {
    const { open, cardToAssign, onHide } = props;
    const {
        t,
        selectedList, // Employee input value
        setSelectedList,
        emptyFields,
        handleConfirm
    } = AssignCardApp(props);

    return (
        <CustomModal
            title={"assign_employee"}
            show={open}
            size="lg"
            buttonConfirm="assign"
            cancelButton={true}
            confirmButton={true}
            onConfirm={handleConfirm}
            onHide={onHide}
            classNameBody="pt-2"
        >
            <div className='row'>

                <div className={"col-12 d-flex"}>
                    <CustomDescriptionLabel trans={t('number').toLowerCase()+ ": "} />
                    <CustomDescriptionLabel trans={cardToAssign?.number} bold={"normal"}/>
                </div>
                <div className={"col-12 d-flex"}>
                    <CustomDescriptionLabel trans={t('facility_code').toLowerCase()+ ": " } />
                    <CustomDescriptionLabel trans={cardToAssign?.facilityCode} bold={"normal"}/>
                </div>
                <div className={"col-12 d-flex"}>
                    <CustomDescriptionLabel trans={t('format').toLowerCase()+ ": "} />
                    <CustomDescriptionLabel trans={cardToAssign?.format} bold={"normal"}/>
                </div>

                <Box className='col-12 mt-4'>
                    <CustomAddChipSearch
                        autocompleteId={'slt_acm_search_employee'}
                        buttonId={'btn_acm_search_employee'}
                        selectedList={selectedList}
                        setSelectedList={setSelectedList}
                        userTypeIdsSearch={[USER_TYPE_MODEL.EMPLOYEE]}
                        disabled={false}
                        label="employee"
                        emptyFields={(emptyFields)}
                        required={true}
                        reset={false}
                        hideButton={true}
                        keyId={"userId"}
                        showRenderOption={true}
                        maxLength={1}
                        helperText={t('select_the_employee_to_be_linked_to_this_card')}
                        showSubSection={true}
                        sanitizeDataList={userListToLabelEmailPhoneValue}
                        Icon={PersonChipBlack}
                    />
                </Box>
            </div>
        </CustomModal>
    );
};

export default AssignCardModal;

